<template>
	<div>
		<iframe
			v-if="dashboardUrl"
			frameborder="0"
			style="width: 100%; height: calc(100vh - 56px);"
			:src="dashboardUrl"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'QuickSightDashboard',
	computed: {
		...mapGetters(['selectedParticipantStore']),
		dashboardUrl() {
			const integrations = this.$store.state.risolto.integrations[this.selectedParticipantStore];
			const qs = integrations?.find(i => i.external_system === 'AWS_QUICKSIGHT');
			return qs?.external_system_identifier || null;
		}
	}
};
</script>
